import React from "react";

export const AppSelect = ({
  label,
  className,
  isRequired = false,
  items = [],
  ...attrs
}) => {
  const { id } = attrs;
  return (
    <div className={className}>
      <label htmlFor={id} className="flex mb-2 font-bold">
        {label}
        {isRequired && (
          <div className="translate-y-1">
            <sup className="text-lg text-canton-jadesheen">*</sup>
          </div>
        )}
      </label>
      <select
        id={id}
        className="w-full border border-sapphire bg-transparent py-3 px-4 text-night-blue outline-none"
        {...attrs}
      >
        <option value="" disabled className="text-night-blue">
          -- please choose an option --
        </option>
        {items.map((item) => (
          <option key={item.value} value={item.value} className="text-night-blue">
            {item.text}
          </option>
        ))}
      </select>
    </div>
  );
};
